import React, { useState } from 'react'

const defaultState = {
  showAdvert: () => (true)
}

export const AdvertisingContext = React.createContext(defaultState)

export const AdvertisingProvider = (props) => {
  const [showAdvert, setShowAdvert] = useState(true)

  return (
    <AdvertisingContext.Provider value={[showAdvert, setShowAdvert]}>
      {props.children}
    </AdvertisingContext.Provider>
  )
}

// export default CartItemsContext
